module.exports = __webpack_public_path__ + "img/hurray.0f0fef21.png";